<div class="my-3 mx-3 card">
  <h1 class="text-center my-4"> Compare with similar items </h1>
  <div class="container-fluid">
    <!-- Compare Table Section -->
    <div class="row">
      <div class="col-12 shadow">
        <div class="table-container">
          <div class="table-responsive">
            <table class="table table-bordered table-hover align-middle text-start">
              <!-- Table Header -->
              <thead class="thead-light">
              <tr>
                <th class="sticky-col"></th>
                <th *ngFor="let product of products">{{ product.name }}</th>
              </tr>
              </thead>
              <!-- Table Body -->
              <tbody>
              <!-- Price Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Price</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.price }}</td>
              </tr>
              <!-- Display Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Display</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.display }}</td>
              </tr>
              <!-- Camera Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Camera</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.camera }}</td>
              </tr>
              <!-- Front Camera Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Front Camera</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.frontCamera }}</td>
              </tr>
              <!-- Face/Touch Id Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Face/Touch Id</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.faceOrTouchID }}</td>
              </tr>
              <!-- Chip Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Chip</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.chip }}</td>
              </tr>
              <!-- Splash, Water and Dust Resistant Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Splash, Water and Dust Resistant</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.splashWaterAndDustResistant }}</td>
              </tr>
              <!-- Wireless Charging Row -->
              <tr>
                <th scope="row" class="text-start ps-4 sticky-col">Wireless Charging</th>
                <td *ngFor="let product of products" class="scrollable-cell">{{ product.wirelessCharging }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
